import { patternPath } from "./pathTools";
export const flattenObject = (v, p = '') => {
    if (Array.isArray(v)) {
        return v.reduce((o, _v, _i) => {
            return Object.assign(o, pv(`${p}[${_i}]`, _v));
        }, Object.create(null));
    }
    if (v && typeof v === 'object') {
        return Object.entries(v).reduce((o, [_k, _v]) => {
            return Object.assign(o, pv(p ? `${p}.${_k}` : _k, _v));
        }, Object.create(null));
    }
    return v;
};
function pv(p, v) {
    return Array.isArray(v) || (v && typeof v === 'object')
        ? {
            [p]: v,
            ...flattenObject(v, p),
        }
        : {
            [p]: v,
        };
}
function findFirstPageChild(childInfo) {
    if (childInfo.children?.length) {
        return findFirstPageChild(childInfo.children[0]);
    }
    else {
        return childInfo.key;
    }
}
export const flattenChildren = (arr = [], flattenKey = 'children') => {
    if (Array.isArray(arr)) {
        return arr.reduce((flattened, { path, ...rest }) => {
            const children = rest[flattenKey];
            // 展开的菜单点击第一级面包屑跳转到第一个菜单
            const redirectPath = children?.length
                ? findFirstPageChild(children[0])
                : '';
            return flattened
                .concat([{ ...rest, redirect: redirectPath, path: patternPath(path) }])
                .concat(children ? flattenChildren(children, flattenKey) : []);
        }, []);
    }
    else {
        return [];
    }
};
